import { axios } from 'setup/axiosSetup';

// Lucky Six runs on its own provider server; our API opens the session
// (POST /lucky6/launch) and tells whether this player may see the game yet
// (staff switch it on per player while it is in testing).

const baseUrl = (): string => process.env.REACT_APP_GAME_API_BACKEND_API ?? '';

export const getLucky6Access = async (): Promise<boolean> => {
  const response = await axios.get(`${baseUrl()}/lucky6/access`, {
    cache: false,
  });
  return !!response.data?.enabled;
};

export const launchLucky6 = async (
  lang: string,
  channel: 'web' | 'mobile'
): Promise<string> => {
  const response = await axios.post(
    `${baseUrl()}/lucky6/launch`,
    { lang, channel },
    { cache: false }
  );
  return response.data.launch_url as string;
};

// Languages the game has; anything else falls back to English.
const GAME_LANGS = ['bs', 'hr', 'sr', 'en', 'de', 'sl', 'mk', 'sq'];
export const lucky6Lang = (appLang: string | undefined): string => {
  const l = (appLang ?? '').slice(0, 2).toLowerCase();
  return GAME_LANGS.includes(l) ? l : 'en';
};
